import { render, staticRenderFns } from "./warningPopup.vue?vue&type=template&id=85e086aa&scoped=true&"
import script from "./warningPopup.vue?vue&type=script&lang=ts&"
export * from "./warningPopup.vue?vue&type=script&lang=ts&"
import style0 from "./warningPopup.vue?vue&type=style&index=0&id=85e086aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e086aa",
  null
  
)

component.options.__file = "warningPopup.vue"
export default component.exports